import { Component, OnInit } from '@angular/core';
import { Station } from '../../models/station';
import { StationUsageService } from '../../statistics/station-usage.service';

@Component({
  selector: 'app-station-usage',
  templateUrl: './station-usage.component.html',
  styleUrls: ['./station-usage.component.css']
})
export class StationUsageComponent implements OnInit {
  mostUsedStation : string;
  mostFullStation : string;

  leastUsedStation : string;
  leastFullStation : string;

  loading = true;


  constructor(private stationUsageStat : StationUsageService) { }

  ngOnInit() {
    // TODO WS

    this.stationUsageStat.getStationUsageStats().subscribe(data => {
      this.mostUsedStation = data.mostUsed
      this.leastUsedStation = data.leastUsed;
      this.mostFullStation = data.mostFull;
      this.leastFullStation = data.leastFull;

      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/station-usage/station-usage.component.ts